export const getAlgoliaPermittedContentTypesFilter = (
  permittedContentTypes: string[]
): string => {
  return permittedContentTypes
    .map(
      (permittedContentType: string) =>
        `field_component:${permittedContentType}`
    )
    .join(' OR ');
};
